import { render, staticRenderFns } from "./DeleteQuestionCategoryModal.vue?vue&type=template&id=7390be9c&scoped=true&"
import script from "./DeleteQuestionCategoryModal.vue?vue&type=script&lang=js&"
export * from "./DeleteQuestionCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7390be9c",
  null
  
)

export default component.exports